import React from 'react';
import { DotIcon } from '@avila-tek/ui';
import { orderPaymentStatusTranslate } from '../../static/orderStatus';

interface ActiveDotDynamicCellProps {
  text: string;
  opctions: { color: string; text: string }[];
}

function ActiveDotDynamicCell({ text, opctions }: ActiveDotDynamicCellProps) {
  const colorClass = `text-${
    opctions.find((option) => option.text === text)?.color
  }-300`;

  return (
    <p className="flex gap-2 items-center capitalize ">
      <DotIcon className={`${colorClass} text-rose-300 w-5 h-5`} />
      {orderPaymentStatusTranslate[text]}
    </p>
  );
}

export default ActiveDotDynamicCell;
